export const addZero = (value: number): string => {
  return value > 9 ? value.toString() : '0' + value.toString();
};
